import { Form, Select, Typography } from "antd";
export const CitiesSelect = ({
  withoutForm,
  name,
  label,
  mode,
  disabled,
  required,
  message,
  value,
  options,
  placeholder,
  ...props
}) => {
  return withoutForm ? (
    <Select
      maxTagCount="responsive"
      value={value || ""}
      mode={mode || ""}
      placeholder={placeholder}
      disabled={disabled || false}
      {...props}
    >
      {options?.map((opt) => (
        <Select.Option value={opt?.id} key={opt?.id}>
          {opt?.name}
        </Select.Option>
      ))}
    </Select>
  ) : (
    <Form.Item
      name={name}
      label={<Typography.Text strong>{label}</Typography.Text>}
      rules={[
        {
          required,
          message,
        },
      ]}
    >
      <Select
        value={value}
        mode={mode || ""}
        disabled={disabled || false}
        maxTagCount="responsive"
        placeholder={placeholder}
        {...props}
      >
        {options?.map((opt) => (
          <Select.Option value={opt?.id} key={opt?.id}>
            {opt?.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
